import React from 'react'
import styled from 'styled-components'
import Box from '@ui/Box'
import NextHead from 'next/head'
import Grid from '@ui/Grid'
import routes from '@routes'
import TryButton from '@components/Landing/TryButton'
import Flex from '@ui/Flex'

const Section = styled.section`
  margin-top: 200px;
  max-width: 1200px;

  @media (max-width: 768px) {
    margin-top: 100px;
  }
`

const Title = styled.h2`
  font-size: 70px;
  font-weight: 500;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 50px;
  }
`

const Subtitle = styled.h2`
  font-size: 42px;
  text-align: center;
  color: #40e0ec;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

const Video = styled.iframe`
  max-width: 1200px;
  width: 100%;
  height: 615px;
  margin-top: 32px;
  border-radius: 30px;
`

const StripeIntegration = () => {
  return (
    <>
      <NextHead>
        <link rel="preload" href="/img/landing/ab.png" as="image" />
        <link rel="preload" href="/img/landing/modern-design.png" as="image" />
        <link rel="preload" href="/img/landing/analytics.png" as="image" />
        <link rel="preload" href="/img/landing/extras.png" as="image" />
      </NextHead>
      <Section id="supported-platforms">
        <Title>Stripe integration</Title>
        <Subtitle>
          Connect Enhanci to your Stripe account and get insights how to optimise your
          revenue
        </Subtitle>

        <Video
          width="560"
          height="315"
          src="https://www.youtube.com/embed/E1fOln87ZQ8?si=ucnzhjnuqbdTp7pY"
          title="Connect Enhanci with your Stripe account and get insights how to optimise your revenue"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />

        <Flex justifyContent="center">
          <TryButton
            href="https://marketplace.stripe.com/apps/enhanci"
            target="_blank"
            prefetch={false}
            noMessage
            label="Install our Stripe app"
          />
        </Flex>
      </Section>
    </>
  )
}

export default StripeIntegration
